import './axios.config'
import Vue from 'vue'
import 'normalize.css'
import 'smartcommerce-iconfont/smartcommerce-iconfont.css'
import './styles/style.scss'
import VueTheMask from 'vue-the-mask'
import I18nHttpService from './shared/services/I18nHttpService'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate'
import { i18nDriver } from './shared/utils/veevalidate-i18n-driver'
import numberFormatFilter from './shared/filters/number-format.filter'
import { fleetwareUIRouter } from './shared/router'
import App from './App'
import EventBus from 'smartcommerce-component-library/utils/EventBus'
import { CartEvent } from 'smartcommerce-component-library'
import VueAnalytics from 'vue-analytics'
import AppConfigService from './shared/services/AppConfigService'
import dateFilter from './shared/filters/date.filter'
import './shared/utils/existing-email-validator'
import { store } from './order-wizard/store'
import { priceMixin } from './shared/mixins/priceMixin'
import { dateMixin } from './shared/mixins/dateMixin'

Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(numberFormatFilter)
Vue.use(VueTheMask)
Vue.filter('date', dateFilter)
Vue.mixin(priceMixin)
Vue.mixin(dateMixin)

EventBus.$on(CartEvent.INIT, async () => {
  const orderWizardStore = await store
  orderWizardStore.dispatch('INIT_CART')
  I18nHttpService.fetch('hu').then(async messages => {
    const i18n = new VueI18n({
      locale: 'hu',
      messages: {
        hu: messages
      },
      silentTranslationWarn: true
    })

    Vue.use(VeeValidate, {
      classes: true,
      classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid'
      },
      i18n
    })

    const router = fleetwareUIRouter(i18n, orderWizardStore)

    const gtagTrackingId = await AppConfigService.getConfigValue('gtagTrackingId')
    gtagTrackingId && Vue.use(VueAnalytics, {
      id: gtagTrackingId,
      router
    })

    VeeValidate.setI18nDriver('custom', i18nDriver(i18n))
    new Vue({
      router,
      i18n,
      store: orderWizardStore,
      render: h => h(App)
    }).$mount('#smartcommerce_fleetware_ui')
  })
})
